import * as React from 'react';
type Props = {
  className?: string;
};
export function DairyFree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Dairy free"
      className={className}
    >
      <path
        d="M8.18137 34.1753L14.7291 26.3272M25.2385 19.1805C24.1653 17.5733 22.4526 17.9052 21.0334 18.6295C18.9925 19.6696 17.0651 20.8667 14.7291 19.9152M21.8831 22.6827V31.3636M24.0657 15.1377L31.8187 5.84611M1.42859 20C1.42859 30.2572 9.74288 38.5714 19.9993 38.5714C30.2572 38.5714 38.5714 30.2572 38.5714 20C38.5714 14.5853 36.2546 9.7119 32.5578 6.31744C29.2518 3.28145 24.8424 1.42859 19.9993 1.42859C9.74288 1.42859 1.42859 9.74288 1.42859 20ZM16.4344 7.58759H15.2734V6.09763H24.5651V7.54776H23.528C23.2101 7.54776 22.9527 7.80519 22.96 8.1231C22.9917 9.59462 23.2042 13.5688 24.5333 16.2471C24.5333 16.2471 25.445 18.676 25.2407 21.3255V32.8454C25.2407 32.8454 24.4596 33.9821 23.0552 33.9563L16.4079 33.9555C16.4079 33.9555 15.2462 34.0057 14.7306 32.8454V20.0081C14.7306 20.0081 14.6738 18.5661 15.3723 16.4757C15.3723 16.4757 17.2244 11.7396 17.0031 8.10539C16.9862 7.81109 16.7295 7.58759 16.4344 7.58759Z"
        stroke="currentColor"
      />
    </svg>
  );
}
